import { css } from '@emotion/core';
import { media, tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
export var walkthrough = {
  name: "i3pbo",
  styles: "margin-bottom:24px;"
};
export var heading = /*#__PURE__*/css("color:", tokens.colors.neutral.heavy.default, ";", designTokenFonts.heading, ";margin-bottom:16px;");
export var thumbnails = {
  name: "hboir5",
  styles: "display:flex;width:100%;"
};
export var thumbnail = /*#__PURE__*/css("position:relative;flex-grow:1;border-radius:3px;background-size:cover;background-repeat:no-repeat;background-position:center;margin-right:16px;:last-of-type{margin-right:0;}padding-bottom:36%;", media('>=tablet'), "{flex-grow:0;width:172px;height:104px;padding:0;}", media('>=desktop'), "{width:308px;height:168px;padding:0;}");
export var thumbnailButton = {
  name: "1reuysi",
  styles: "position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);"
};